import * as React from 'react';
import { useSelector } from 'react-redux';

import { useIsMobileDevice } from '../../hooks';
import { IOfferHomeowner } from '../../redux/reducers';
import { selectFormattedHomeowner } from '../../selectors/offer/selectFormattedHomeowner';

import { ContinueButton } from './components/ContinueButton/ContinueButton';
import { CommercialOwnershipVerificationForm } from './components/CommercialOwnershipVerificationForm';
import { FormPreview } from './components/FormPreview';
import { areAllFieldsRequiredFilled } from './components/CommercialOwnershipVerificationForm/internal/utils';

interface ICommercialOwnershipWidget {
  onChange(homeOwner: IOfferHomeowner | undefined): void;
  onClear(): void;
}

export const CommercialOwnershipWidget: React.FC<ICommercialOwnershipWidget> = ({ onClear, onChange }) => {
  const isMobile = useIsMobileDevice();
  const formInitialState = useSelector(selectFormattedHomeowner);

  const [isFormVisible, setFormVisible] = React.useState(() => {
    if (!formInitialState) {
      return false;
    }

    return !areAllFieldsRequiredFilled(formInitialState);
  });

  const [isPreviewVisible, setPreviewVisible] = React.useState(
    () => !isFormVisible && formInitialState && areAllFieldsRequiredFilled(formInitialState),
  );

  const handleContinueButtonClick = React.useCallback(() => {
    setFormVisible(true);
  }, []);
  const handleCancelButtonClick = React.useCallback(() => {
    setFormVisible(false);

    onClear();
  }, []);
  const handleSubmitButtonClick = React.useCallback(() => {
    setPreviewVisible(true);
  }, []);
  const handleEditButtonClick = React.useCallback(() => {
    setPreviewVisible(false);
    setFormVisible(true);
  }, []);

  if (isPreviewVisible) {
    return <FormPreview formState={formInitialState} onEdit={handleEditButtonClick} />;
  }

  if (isFormVisible) {
    return (
      <CommercialOwnershipVerificationForm
        isMobile={isMobile}
        onSubmit={handleSubmitButtonClick}
        onCancel={handleCancelButtonClick}
        formInitialState={formInitialState}
        onChange={onChange}
      />
    );
  }

  return <ContinueButton isMobile={isMobile} onClick={handleContinueButtonClick} />;
};

CommercialOwnershipWidget.displayName = 'CommercialOwnershipWidget';
